import * as React from 'react';
import {AccountPlanFormContainer} from '../../components/alderaan/plans/AccountPlanFormContainer'; // from '../../components/alderaan/plans/AccountPlanFormContainer';

function AccountPlanForm(props) : JSX.Element{
  return <AccountPlanFormContainer {...props} />;
}

export default AccountPlanForm;